<template>
  <div class="container">
    <h2 class="page-title">Configuration Management</h2>
    <p class="page-description">
      In this page you can export the current state of the company as a config
      file which can be used to migrate the company to another environment or
      update the company configuration.
    </p>

    <ts-tabs @tab-click="onTabClick">
      <ts-tab
        id="export"
        data-testid="export-tab"
        v-if="permissions.can_export_configuration"
        :selected.attr="selectedTab === 'export' || null"
        label="Export Configuration"
      >
        <TenantConfigurationExport :tenant="tenant" @open-report="openReport" />
      </ts-tab>
      <ts-tab
        id="update"
        v-if="
          permissions.can_export_configuration &&
          (permissions.can_update_configuration ||
            permissions.can_view_configuration_delta)
        "
        :label.attr="'Update Configuration'"
        :selected.attr="selectedTab === 'update' || null"
      >
        <TenantConfigurationUpdate
          :tenant="tenant"
          :key="taskId"
          @task-created="openReport"
        />
      </ts-tab>
      <ts-tab
        label="Tasks history"
        id="tasks"
        :selected="selectedTab === 'tasks' || null"
      >
        <div class="tab-content">
          <EdifierTenantTasks
            v-if="selectedTab === 'tasks'"
            :tenant-id="tenant.CompanyAccountId"
            @open-report="openReport"
          />
        </div>
      </ts-tab>
      <ts-tab
        v-if="isReportVisible"
        id="report"
        :label="`Report of ${taskId}`"
        :selected="selectedTab === 'report'"
      >
        <div class="tab-content">
          <EdifierReport :task-id="taskId" />
        </div>
      </ts-tab>
    </ts-tabs>
  </div>
</template>

<script>
import '@tradeshift/elements.tabs';
import '@tradeshift/elements.tab';

import EdifierTenantTasks from './Configuration/EdifierTenantTasks';
import TenantConfigurationExport from './TenantConfigurationExport';
import TenantConfigurationUpdate from './TenantConfigurationUpdate';
import EdifierReport from '../../PlatformManagement/EdifierReport.vue';

export default {
  components: {
    TenantConfigurationExport,
    TenantConfigurationUpdate,
    EdifierReport,
    EdifierTenantTasks,
  },
  props: {
    tenant: { type: Object, default: null },
    permissions: { type: Object, default: null },
  },
  data() {
    return {
      taskId: null,
      selectedTab: this.permissions.can_export_configuration
        ? 'export'
        : 'update',
    };
  },
  computed: {
    isReportVisible() {
      const hasPermission =
        this.permissions.can_export_configuration ||
        this.permissions.can_update_configuration ||
        this.permissions.can_view_configuration_delta;
      return !!this.taskId && hasPermission;
    },
  },
  methods: {
    openReport(taskId) {
      this.taskId = taskId;
      this.selectedTab = 'report';
    },
    onTabClick(event) {
      this.selectedTab = event?.detail?.tab?.id;
    },
  },
};
</script>

<style scoped>
.page-title {
  font-weight: var(--ts-fontweight-bold);
}

.page-description {
  font-size: var(--ts-fontsize);
  color: var(--ts-color-slate-lightest);
  margin-bottom: var(--ts-unit-plus);
}

.tab-content {
  padding: 1em;
}
</style>
